import { css } from "@emotion/css"

import Button from "../..//html/Button"
import Triangle from "../../shape/Triangle"

const Spinner = ({ onLongPress, direction }: { onLongPress: () => void; direction: "top" | "bottom" }) => {
  return (
    <Button
      className={style}
      hoverClassName={hoverClassName}
      activeClassName={activeClassName}
      tabIndex={-1}
      onLongPress={onLongPress}
      aria-hidden
      render={({ isActive }) => (
        <Triangle direction={direction} base={8} height={4} color={isActive ? "#ffffff" : "#333333"} />
      )}
    />
  )
}

export default Spinner

const style = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 15px;
  height: 10px;
  line-height: 10px;
  background-color: #efefef;
  border: none;
`

const hoverClassName = css`
  background-color: #999999;
`

const activeClassName = css`
  background-color: #333333;
`
